import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDynamicDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class Food extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getDynamicDataList('95013-');

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { foodMd, foodSlide, foodFeed, foodAd, isAsync } = content;

        const normalTabsData = foodMd;
        const viewMoreLinkData = (foodMd && foodMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : foodFeed;
        const mdBannerData = foodSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50161',
                type: 'struct',
                title: '美食子导航数据',
                groupName: 'content',
                translate: 'handleHomeFinanceMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '75185',
                type: 'recommend',
                title: '美食焦点图数据',
                groupName: 'content',
                translate: 'handleHomeFinanceSlideInfo',
            };
        }
        const moduleData = {
            normalTabsData,
            feedAd: foodAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.food}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(Food);
